import React, { useState } from 'react'
import AOS from 'aos'
import './App.css'
import 'antd/dist/antd.min.css'
import "bootstrap/dist/css/bootstrap.min.css"
import { Routing } from './Config/routes'
import Address from './Screens/Address/Address'
// import Details from './Screens/Details/Details'
import Payment from './Screens/Payment/Payment'
import Home from './Screens/Home/Home'
import Roof from './Screens/Roof/Roof'

AOS.init()

const App = () => {
  const [value, setValue] = useState(null)
  const [center, setCenter] = useState({ lat: 0, lng: 0 })
  const [marker, setMarker] = useState({ lat: null, lng: null })
  const [prenom, setPrenom] = useState(null)
  const [nom, setNom] = useState(null)
  const [telephone, setTelephone] = useState(null)
  const [email, setEmail] = useState(null)
  const [selectedValue, setSelectedValue] = useState({
    val: '20-35m2',
    opt: 1
  })

  return (
    <div>
      <Home setPrenom={setPrenom} setNom={setNom} setTelephone={setTelephone} setEmail={setEmail}
        email={email}
        nom={nom}
        prenom={prenom}
        telephone={telephone}
        setSelectedValue={setSelectedValue}
        selectedValue={selectedValue}
        setValue={setValue} value={value} setCenter={setCenter} center={center} setMarker={setMarker} marker={marker}
      />
      {/* <Roof /> */}
    </div>
  )
}

export default App